import React, {useEffect} from 'react';
import { Route, useRouteMatch, useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStores, useResponsive, useNonMobile } from 'hooks';
import { Content } from 'assets/ContainerStyles';
import MultiAuctionWrapper from 'components/AuctionWrapper';
import { PinnedNav, LayoutViewButtons } from 'components/project';
import BidActivity from 'components/project/Views/BidActivity/Mobile';
import Header from 'components/project/Header';
import Lanes from 'components/project/Views/Lanes';
import LoadingModal from 'components/shared/LoadingModal';
import NavbarLeft from 'components/project/NavbarLeft';
import Settings from 'components/project/Views/Settings';
import { Layout, NoLanesSelected } from './Styles';
import { ROUTES } from '../../../shared/constants/index';
import {getActiveAuctions} from "../../../shared/utils/localStorage";

const NPAMiniLayout = () => {
  const {
    MultiAuctionStore: { connected, auctions, addAuction },
    UIStore: {
      loading, hasPinnedNav: isPinned, setScrollPosition, handleJoinLane,
    },
    providerStore,
    DataStore: { addNewConnection },
  } = useStores();

  const { isMobileView } = useResponsive();
  const isPinnedAndNotMobile = isPinned && !isMobileView;
  const history = useHistory();
  const notifications = {};

  useEffect(() => {
    // Retrieve saved auctions from localStorage
    const savedAuctions = getActiveAuctions(8);

    if (savedAuctions.length < 1) {
      history.push(`${ROUTES.login}?state=expired`);
      return;
    }

    savedAuctions.forEach(({ key, auctionID, auctionInfo }) => {
      if (!auctions.has(key)) {
        // addAuction(auctionID, auctionInfo, providerStore);
        // Initialize the WebSocket connection for each auction
        addNewConnection({ key, auctionID }).then(res => {
          if (res?.error && !res.success) {
            history.push(`${ROUTES.login}?state=expired`);
          }
        })
      }
    });
  }, [connected, auctions, providerStore, history]);


  const match = useRouteMatch();
  // useNonMobile({
  //   isMobileView,
  //   mobileClosedLanes,
  //   deleteMobileClosedLane,
  //   handleJoinLane,
  // });

    return (
    <Layout isPinned={isPinnedAndNotMobile} onScroll={(e) => setScrollPosition(e.target.scrollTop)}>
      <Header />
      {!isMobileView && <LayoutViewButtons />}
      <Content isPinned={isPinned}>
        <Route path={`${match.path}${ROUTES.lanes}`} render={() => <Lanes />} />
        <Route
          path={`${match.path}${ROUTES.settings}`}
          render={() => <Settings />}
        />
        <Route
          path={`${match.path}${ROUTES.bidActivity}`}
          render={() => <BidActivity />}
        />
        <Route
          path={`${ROUTES.auction}`}
          exact
          render={() => <MultiAuctionWrapper auctions={auctions} />}
        />
      </Content>
      <NavbarLeft  />
      {isPinned && <PinnedNav />}
      {/*{isMobileView && <MobileNavbarLeft />}*/}
      {loading && <LoadingModal />}
    </Layout>
  );
};

export default observer(NPAMiniLayout);
